import { FC, useContext, useState } from "react";
import NotificationDispatch, {
  showErrorNotification,
  showSuccessNotification,
} from "../../context/notificationContext";
import { useI18n } from "../../hooks/useTranslations";
import { useOtherCarAssignmentApi } from "../../http/otherCarAssignment/api";
import { OtherCarAssignment } from "../../http/otherCarAssignment/types";
import ModalDialog from "../ui/ModalDialog";

type DeleteOtherCarAssignmentDialogProps = {
  otherCarAssigment: OtherCarAssignment;
  onClose: (success?: boolean) => void;
};

const DeleteOtherCarAssignmentDialog: FC<DeleteOtherCarAssignmentDialogProps> = ({ otherCarAssigment, onClose }) => {
  const i18n = useI18n();
  const otherCarAssignmentApi = useOtherCarAssignmentApi();
  const dispatch = useContext(NotificationDispatch);
  const [isSubmitting, setIsSubmitting] = useState(false);

  return (
    <ModalDialog
      onClose={onClose}
      title={i18n.t.otherCarAssignments.delete}
      isSubmitting={isSubmitting}
      actions={[
        {
          title: i18n.t.common.cancel,
          type: "secondary",
          onClick: onClose,
        },
        {
          title: i18n.t.common.yes,
          onClick: () => {
            setIsSubmitting(true);
            otherCarAssignmentApi
              .deleteOtherCarAssignment(otherCarAssigment)
              .catch((err) => dispatch(showErrorNotification(i18n, err)))
              .then(() => {
                onClose(true);
                dispatch(showSuccessNotification(i18n.t));
              })
              .finally(() => setIsSubmitting(false));
          },
        },
      ]}
    >
      {i18n.t.otherCarAssignments.questions.delete}
    </ModalDialog>
  );
};

export default DeleteOtherCarAssignmentDialog;
